<template>
  <section class="delivery_details">
    <div class="group">
      <paragraph-header v-if="fieldsGroup[0].label" size="2">
        {{ $t(fieldsGroup[0].label) }}
        <span>({{ $t(fieldsGroup[0].subLabel1) }}):</span>
      </paragraph-header>
      <div class="fields_list">
        <div class="field is_long">
          <input
            type="text"
            v-model="_self['shippingStreet']"
            id="shippingStreet"
            required="true"
            name="shippingStreet"
            placeholder=""
            :class="{ is_filled: _self['shippingStreet'] }"
            ref="shippingStreet"
          />
          <label for="shippingStreet">
            {{ $t('Address') }}
          </label>
        </div>
        <div
          class="field"
          v-for="field in fieldsGroup[0].fields.filter((v) => v.id !== 'shippingStreet')"
          :key="field.key"
          :class="[...field.class]"
        >
          <input
            v-if="['text', 'email', 'phone'].indexOf(field.type) !== -1"
            :type="field.type"
            v-model="_self[field.key]"
            :id="field.id"
            :required="field.require"
            :name="field.id"
            :class="{ is_filled: _self[field.key] }"
            :ref="field.id"
            :disabled="fieldsGroup[0].canBeCopied && areAddressesSame"
          />

          <input
            type="checkbox"
            class="styled"
            :id="field.id"
            v-if="field.type === 'checkbox'"
            v-model="_self[field.key]"
          />

          <textarea
            v-if="field.type === 'textarea'"
            v-model="_self[field.key]"
            :id="field.id"
            :required="field.require"
            :name="field.name"
            :disabled="fieldsGroup[0].canBeCopied && areAddressesSame"
            @input="onTextAreaChange"
            :class="{ is_filled: _self[field.key] }"
          ></textarea>
          <label :for="field.id">
            <span v-if="field.type === 'checkbox'" class="checkbox_presentation">
              <svg width="12" height="12" viewbox="0 0 24 24">
                <use xlink:href="#tick"></use>
              </svg>
            </span>
            {{ $t(field.label) }}
          </label>
          <span class="note" v-if="field.note">{{ $t(field.note) }}</span>
        </div>
      </div>
    </div>
    <div class="group">
      <paragraph-header v-if="fieldsGroup[1].label" size="2">
        {{ $t(fieldsGroup[1].label) }}
        <span>({{ $t(fieldsGroup[1].subLabel1) }}):</span>
      </paragraph-header>
      <div class="field is_long">
        <input
          type="text"
          v-model="_self['pickupStreet']"
          id="pickupStreet"
          required="true"
          name="pickupStreet"
          placeholder=""
          :class="{ is_filled: _self['pickupStreet'] }"
          ref="pickupStreet"
          :disabled="areAddressesSame"
        />
        <label for="pickupStreet">
          {{ $t('Address') }}
        </label>
      </div>
      <div class="fields_list">
        <div
          class="field"
          v-for="field in fieldsGroup[1].fields.filter((v) => v.id !== 'pickupStreet')"
          :key="field.key"
          :class="[...field.class]"
        >
          <input
            v-if="['text', 'email', 'phone'].indexOf(field.type) !== -1"
            :type="field.type"
            v-model="_self[field.key]"
            :id="field.id"
            :required="field.require"
            :name="field.id"
            :class="{ is_filled: _self[field.key] }"
            :ref="field.id"
            :disabled="fieldsGroup[1].canBeCopied && areAddressesSame"
          />

          <input
            type="checkbox"
            class="styled"
            :id="field.id"
            v-if="field.type === 'checkbox'"
            v-model="_self[field.key]"
          />

          <textarea
            v-if="field.type === 'textarea'"
            v-model="_self[field.key]"
            :id="field.id"
            :required="field.require"
            :name="field.name"
            :disabled="fieldsGroup[1].canBeCopied && areAddressesSame"
            @input="onTextAreaChange"
            :class="{ is_filled: _self[field.key] }"
          ></textarea>
          <label :for="field.id">
            <span v-if="field.type === 'checkbox'" class="checkbox_presentation">
              <svg width="12" height="12" viewbox="0 0 24 24">
                <use xlink:href="#tick"></use>
              </svg>
            </span>
            {{ $t(field.label) }}
          </label>
          <span class="note" v-if="field.note">{{ $t(field.note) }}</span>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { Loader } from '@googlemaps/js-api-loader'
import { mapActions, mapState } from 'vuex'
import ParagraphHeader from '../atoms/ParagraphHeader.vue'

const fieldsGroup = [
  {
    label: 'shippingAddress',
    subLabel1: 'beforeMove',
    fields: [
      {
        type: 'text',
        id: 'shippingStreet',
        key: 'shippingStreet',
        label: 'Address',
        require: true,
        value: '',
        class: ['is_long'],
      },
      {
        type: 'text',
        id: 'shippingPostCode',
        key: 'shippingPostCode',
        label: 'zipCode',
        require: true,
        class: ['is_short'],
        value: '',
      },
      {
        type: 'text',
        id: 'shippingCity',
        key: 'shippingCity',
        label: 'City',
        class: ['is_city'],
        require: true,
        value: '',
      },
      {
        type: 'textarea',
        id: 'shippingNote',
        key: 'shippingNote',
        label: 'Additional Information',
        require: false,
        value: '',
      },
      {
        type: 'checkbox',
        id: 'areAddressesSame',
        key: 'areAddressesSame',
        label: 'sameDeliveryAddressBeforeAndAfterMoving',
        require: false,
        value: true,
      },
    ],
  },
  {
    label: 'pickupAddress',
    subLabel1: 'afterMove',
    canBeCopied: true,
    fields: [
      {
        type: 'text',
        id: 'pickupStreet',
        key: 'pickupStreet',
        label: 'Address',
        require: true,
        value: '',
        class: ['is_long'],
      },
      {
        type: 'text',
        id: 'pickupPostCode',
        key: 'pickupPostCode',
        label: 'zipCode',
        require: true,
        class: ['is_short'],
        value: '',
      },
      {
        type: 'text',
        id: 'pickupCity',
        key: 'pickupCity',
        label: 'City',
        require: true,
        class: ['is_city'],
        value: '',
      },
      {
        type: 'textarea',
        id: 'pickupNote',
        key: 'pickupNote',
        label: 'Additional Information',
        require: false,
        value: '',
      },
    ],
  },
]

const dynamicComputedProperty = () => {
  const result = {}
  const fields = fieldsGroup.reduce((sum, current) => {
    return [...sum, ...current.fields]
  }, [])

  fields.forEach((field) => {
    const commitNameKey = field.key.charAt(0).toUpperCase() + field.key.slice(1)

    result[field.key] = {
      set(value) {
        this.$store.commit(`user/set${commitNameKey}`, value)
      },
      get() {
        return this.$store.state.user[field.key]
      },
    }
  })

  return result
}

export default {
  components: { ParagraphHeader },
  name: 'DeliveryDetails',
  data() {
    return {
      fieldsGroup: fieldsGroup,
    }
  },
  computed: {
    ...dynamicComputedProperty(),
    ...mapState[('user', ['areAddressesSame'])],
    ...mapState('user', {
      userCountry: 'shippingCountry',
    }),
  },
  mounted() {
    this.$nextTick(() => {
      this.loadGoogleMaps()
    })
  },
  methods: {
    ...mapActions('cart', ['setOrderStepBySlug']),
    onTextAreaChange(ev) {
      const element = ev.target
      element.style.height = '5px'
      element.style.height = element.scrollHeight + 'px'
    },
    loadGoogleMaps() {
      const loader = new Loader({
        apiKey: window.gm_object.key,
        version: 'weekly',
        libraries: ['places'],
      })

      loader.load().then((google) => this.autocomplete(google))
    },
    formatAddress(address) {
      const formattedAddress = {}
      if (!address) return true
      for (const component of address.address_components) {
        // @ts-ignore remove once typings fixed
        const componentType = component.types[0]

        switch (componentType) {
          case 'route': {
            formattedAddress.street = `${component.short_name} ${formattedAddress?.streetNumber || ''}`
            break
          }

          case 'street_number': {
            formattedAddress.streetNumber = component.long_name
            break
          }

          case 'postal_code': {
            formattedAddress.postcode = component.long_name
            break
          }

          case 'locality':
            formattedAddress.city = component.long_name
            break

          // case 'administrative_area_level_1': {
          //   formattedAddress.administrative_area_level_1 = component.long_name
          //   break
          // }

          case 'country':
            formattedAddress.country = component.long_name
            break
        }
      }

      return formattedAddress
    },
    autocomplete(google) {
      const options = {
        fields: ['formatted_address', 'geometry', 'name', 'address_components'],
        strictBounds: false,
        componentRestrictions: { country: this.userCountry },
        types: ['locality', 'route'],
      }

      const autocomplete_before = new google.maps.places.Autocomplete(this.$refs.shippingStreet, options)
      const autocomplete_after = new google.maps.places.Autocomplete(this.$refs.pickupStreet, options)

      autocomplete_before.addListener('place_changed', () => {
        const place = autocomplete_before.getPlace()
        const formattedAddress = this.formatAddress(place)
        if (formattedAddress) {
          this.shippingStreet = formattedAddress.street
          this.shippingPostCode = formattedAddress.postcode
          this.shippingCity = formattedAddress.city
        }
      })

      autocomplete_after.addListener('place_changed', () => {
        const place = autocomplete_after.getPlace()
        const formattedAddress = this.formatAddress(place)
        if (formattedAddress) {
          this.pickupStreet = formattedAddress.street
          this.pickupPostCode = formattedAddress.postcode
          this.pickupCity = formattedAddress.city
        }
      })
    },
  },
  watch: {
    areAddressesSame(newValue) {
      if (newValue) {
        this.$store.commit('user/setPickupStreet', null)
        this.$store.commit('user/setPickupPostCode', null)
        this.$store.commit('user/setPickupCity', null)
        this.$store.commit('user/setPickupNote', null)
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.delivery_details {
  @include container();
  display: flex;
  flex-wrap: wrap;
  // justify-content: space-between;
}

.group {
  margin-top: 75px;
  flex: 1 1 auto;
  max-width: 420px;

  @include mq($from: tablet) {
    flex: 0 1 47%;
    margin-right: 6%;

    &:last-child {
      margin-right: 0;
    }
  }

  &.var_small_space {
    margin-top: 0px;
  }
}

.fields_list {
  display: flex;
  align-items: flex-start;
  flex-wrap: wrap;
  // width: calc(100% + 30px);

  @include mq($from: tablet) {
    width: auto;
  }
}

.field {
  margin: 20px 0 0 0;
  position: relative;
  flex: 1 1 auto;

  @include mq($from: tablet) {
    margin: 30px 0 0 0;
  }

  &.is_long {
    flex: 1 1 100%;
  }

  &.is_city {
    flex: 1 1 calc(100% - 95px);

    @include mq($from: tablet) {
      flex: 1 1 calc(100% - 105px);
    }
  }

  &.is_short {
    flex: 1 1 75px;
    margin-right: 20px;
    max-width: 75px;

    @include mq($from: tablet) {
      margin-right: 30px;
    }
  }

  textarea {
    min-height: 110px;
  }
}
</style>
